/**
 * Represents the result of attempting to create a new card on file for a user.
 */
export enum CreateCardOnFileStatus {
    /**
     * Indicates the card on file was successfully created.
     */
    Success = 0,

    /**
     * Indicates the card on file creation failed due to a duplicate payment method.
     */
    DuplicatePaymentMethod = 1,
}
